module.exports = __webpack_public_path__ + "static/media/11x14no2.b7b5de39.jpg";